// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employee-widget {
  position: relative;
}
.employee-widget .publishDate-container {
  font-size: 13px;
  color: #666;
  position: absolute;
  top: 15px;
  right: 15px;
}
.employee-widget .news-stream-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  gap: 10px;
  justify-content: start !important;
}
.employee-widget .no-news-container {
  text-align: center;
  font-size: 14px;
  color: #666;
  margin-block: auto;
}
.employee-widget .employee-details {
  display: flex;
  justify-content: start;
  flex-direction: column;
  gap: 3px;
}
.employee-widget .details-section {
  display: flex;
  gap: 10px;
  border-radius: 8px;
}
.employee-widget .details-section .icon-container {
  display: flex;
  align-items: flex-start;
  margin-top: 2px;
}
.employee-widget .details-section .icon-container ion-icon {
  font-size: 24px;
  color: #ed143d;
}
.employee-widget .details-section .value {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 600;
  word-break: break-word;
}
.employee-widget .details-section .value .label {
  font-size: 12px;
  color: #666;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/widgets/portal-feed/portal-feed.component.scss"],"names":[],"mappings":"AAEA;EAEE,kBAAA;AAFF;AAIE;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAFJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;EACA,SAAA;EACA,iCAAA;AAFJ;AAIE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAFJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,QAAA;AAFJ;AAME;EACE,aAAA;EACA,SAAA;EAEA,kBAAA;AALJ;AAMI;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AAJN;AAKM;EACE,eAAA;EACA,cAAA;AAHR;AAOI;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AALN;AAMM;EACE,eAAA;EACA,WAAA;AAJR","sourcesContent":["  \n\n.employee-widget {\n\n  position: relative;\n\n  .publishDate-container {\n    font-size: 13px;\n    color: #666;\n    position: absolute;\n    top: 15px;\n    right: 15px;\n  }\n  .news-stream-container {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n    gap: 10px;\n    justify-content: start !important;\n  }\n  .no-news-container {\n    text-align: center;\n    font-size: 14px;\n    color: #666;\n    margin-block: auto;\n  }\n  .employee-details {\n    display: flex;\n    justify-content: start;\n    flex-direction: column;\n    gap: 3px;\n \n  }\n\n  .details-section {\n    display: flex;\n    gap: 10px;\n\n    border-radius: 8px;\n    .icon-container {\n      display: flex;\n      align-items: flex-start;\n      margin-top: 2px;\n      ion-icon {\n        font-size: 24px;\n        color: #ed143d;\n      }\n    }\n\n    .value {\n      display: flex;\n      flex-direction: column;\n      font-size: 14px;\n      font-weight: 600;\n      word-break: break-word;\n      .label {\n        font-size: 12px;\n        color: #666;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
